import React from 'react';
import { Divider } from 'semantic-ui-react'

const ConfEqu1 = ({autorizacUA, styles, handleClickRegr, handleClickSel1, handleClickSel2,
                    handleClickSel3, handleClickSel4}) => {
  const a252515 = autorizacUA.findIndex( autorizac => autorizac === "252515" );
  const a252520 = autorizacUA.findIndex( autorizac => autorizac === "252520" );
  const a252525 = autorizacUA.findIndex( autorizac => autorizac === "252525" );
  const a252530 = autorizacUA.findIndex( autorizac => autorizac === "252530" );

  return (
    <div>
      <button className="ui right labeled icon button fluid" style={styles.titBuscar}>
        <i className="large sitemap yellow icon"></i>
        Opciones
      </button>

      {a252515!==-1 &&
      <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel1}>
        <i className="large microchip violet icon"></i>
        Clases de equipos
      </button>
      }
      {a252520!==-1 &&
      <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel3}>
        <i className="large building outline violet icon"></i>
        Fabricantes de equipos
        </button>
      }
      {a252525!==-1 &&
      <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel2}>
        <i className="large registered outline violet icon"></i>
        Marcas de equipos
        </button>
      }
      {a252530!==-1 &&
      <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel4}>
        <i className="large warehouse violet icon"></i>
        Bodegas
      </button>
      }
      
      {(a252515!==-1||a252520!==-1||a252525!==-1||a252530!==-1) &&
      <Divider inverted />
      }
      
      <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickRegr}>
        <i className="large arrow left violet icon"></i>
        Regresar
      </button>

    </div>
  )
};

export default ConfEqu1
